import React, { useCallback, useState, memo, useEffect } from 'react';

import { Input } from '../common-inputs';
import ColorPicker from './ColorPicker';
import hexWithAlpha from '../../utils/hexWithAlpha';
import getAlphaFromHex from '../../utils/getAlphaFromHex';

import './ColorInput.scss';

const ColorInput = ({
  color = '#FFFFFF',
  size = 'sm',
  maxWidth,
  onChange,
  placeholder,
  tabIndex,
  isError,
  onFocus,
  onBlur,
  disableAlpha,
  disabled,
}) => {
  const [currentColor, setCurrentColor] = useState({ hex: color });
  const [currentOpacity, setCurrentOpacity] = useState(getAlphaFromHex(color) ?? 100);
  const [showPicker, setShowPicker] = useState(false);

  const handleColorChange = useCallback(
    (newColor) => {
      setCurrentColor(newColor);
      onChange(hexWithAlpha({ hex: newColor.hex, alpha: currentOpacity }));
    },
    [onChange, currentOpacity],
  );

  const togglePicker = useCallback(() => {
    if (!disabled) {
      setShowPicker((prevState) => !prevState);
    }
  }, [disabled]);

  useEffect(() => {
    if (currentColor.hex) {
      onChange(hexWithAlpha({ hex: currentColor.hex, alpha: parseInt(currentOpacity) }));
    }
  }, [currentOpacity, currentColor, onChange]);

  return (
    <div className='color-input_wrapper' style={{ maxWidth }}>
      <Input
        type='text'
        value={color}
        onChange={onChange}
        size={size}
        placeholder={placeholder}
        tabIndex={tabIndex}
        isError={isError}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        RightIcon={
          <div
            style={{
              width: '19px',
              height: '19px',
              background: color,
              cursor: 'pointer',
              borderRadius: '5px',
            }}
            onClick={togglePicker}
          />
        }
      />

      {showPicker ? (
        <div className={'color-input_popover'}>
          <div className={'color-input_cover'} onClick={togglePicker} />

          <ColorPicker
            color={currentColor}
            onChange={handleColorChange}
            opacity={currentOpacity}
            onChangeOpacity={setCurrentOpacity}
            disableAlpha={disableAlpha}
          />
        </div>
      ) : null}
    </div>
  );
};

export default memo(ColorInput);
